import * as React from 'react';

import Drumkit from '../assets/drumkit-logo.png';

export default function DrumkitLogo(
  props: React.ImgHTMLAttributes<HTMLImageElement>
): React.JSX.Element {
  return <img src={Drumkit} alt='Drumkit logo' {...props} />;
}
